var render = function (_h,_vm) {var _c=_vm._c;return _c('ActionLink',_vm._g(_vm._b({staticClass:"remove-button",class:_vm.data.staticClass,attrs:{"icon":"remove","size":_vm.props.size}},'ActionLink',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }